// extracted by mini-css-extract-plugin
export var typingIndicator = "_nv-0";